// Regras puras do cadastro de tutoriais (PO1-3505): formulário, validação e
// payload. Sem React, para testar isolado. Os limites são os da tabela
// dbo.TreinamentoTutorial e das validações do backend_hub.
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
import { PRODUTOS_TUTORIAL } from "../../Treinamento/rotas";

export const LIMITES = { codigo: 80, titulo: 200, resumo: 500, permissao: 300, manualNome: 255 };
export const REGEX_CODIGO = /^[a-z0-9-]{3,80}$/;
export const REGEX_YOUTUBE = /^[A-Za-z0-9_-]{11}$/;
const CODIGOS_PRODUTO = PRODUTOS_TUTORIAL.map((p) => p.codigo);

export function hojeIso() {
  const d = new Date();
  const dois = (v) => (v < 10 ? `0${v}` : String(v));
  return `${d.getFullYear()}-${dois(d.getMonth() + 1)}-${dois(d.getDate())}`;
}

export function criarFormVazio() {
  return {
    codigo: "",
    titulo: "",
    resumo: "",
    produtos: [],
    permissao: "",
    youtubeId: "",
    duracaoSegundos: "",
    dataPublicacao: hojeIso(),
    ordem: "0",
    status: "active",
    capitulos: [],
    telas: [],
    passos: [],
    conteudoTexto: "",
  };
}

const str = (v) => (v === null || v === undefined ? "" : String(v));

// Aceita o youtubeId cru ou a URL inteira (youtu.be/<id>, watch?v=<id>, embed/<id>).
export function extrairYoutubeId(valor) {
  const v = str(valor).trim();
  if (!v) return "";
  if (REGEX_YOUTUBE.test(v)) return v;
  const m = v.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : v;
}

// "2:45" ou "165" → 165. Devolve NaN quando inválido; null quando vazio.
export function parseDuracao(valor) {
  const v = str(valor).trim();
  if (!v) return null;
  if (/^\d+$/.test(v)) return Number(v);
  const m = v.match(/^(?:(\d+):)?(\d{1,2}):(\d{2})$/);
  if (!m) return NaN;
  const h = Number(m[1] || 0);
  const min = Number(m[2]);
  const s = Number(m[3]);
  if (min > 59 || s > 59) return NaN;
  return h * 3600 + min * 60 + s;
}

export function formDoTutorial(t) {
  const form = criarFormVazio();
  if (!t) return form;
  return {
    ...form,
    codigo: str(t.codigo),
    titulo: str(t.titulo),
    resumo: str(t.resumo),
    produtos: Array.isArray(t.produtos) ? t.produtos.slice() : [],
    permissao: Array.isArray(t.permissao) ? t.permissao.join(",") : str(t.permissao),
    youtubeId: str(t.youtubeId),
    duracaoSegundos: t.duracaoSegundos === null || t.duracaoSegundos === undefined ? "" : String(t.duracaoSegundos),
    dataPublicacao: str(t.dataPublicacao).slice(0, 10) || hojeIso(),
    ordem: t.ordem === null || t.ordem === undefined ? "0" : String(t.ordem),
    status: t.status === false || t.status === 0 || t.status === "0" ? "inactive" : "active",
    capitulos: (Array.isArray(t.capitulos) ? t.capitulos : []).map((c) => ({ s: str(c && c.s), titulo: str(c && c.titulo) })),
    telas: (Array.isArray(t.telas) ? t.telas : []).map((x) => ({ rota: str(x && x.rota), aba: str(x && x.aba), s: str(x && x.s) })),
    passos: (Array.isArray(t.passos) ? t.passos : []).map((p) => str(p)),
    conteudoTexto: str(t.conteudoTexto),
  };
}

export function validarForm(form) {
  const erros = {};
  const codigo = str(form.codigo).trim();
  const titulo = str(form.titulo).trim();
  if (!codigo) erros.codigo = "Informe o código.";
  else if (!REGEX_CODIGO.test(codigo)) erros.codigo = "Só letras minúsculas, números e hífen (3 a 80).";
  if (!titulo) erros.titulo = "Informe o título.";
  else if (titulo.length > LIMITES.titulo) erros.titulo = `Máximo de ${LIMITES.titulo} caracteres.`;
  if (str(form.resumo).trim().length > LIMITES.resumo) erros.resumo = `Máximo de ${LIMITES.resumo} caracteres.`;
  const produtos = Array.isArray(form.produtos) ? form.produtos : [];
  if (produtos.length === 0) erros.produtos = "Escolha pelo menos um produto.";
  else if (produtos.some((p) => CODIGOS_PRODUTO.indexOf(p) === -1)) erros.produtos = "Produto desconhecido.";
  if (str(form.permissao).trim().length > LIMITES.permissao) erros.permissao = `Máximo de ${LIMITES.permissao} caracteres.`;
  const youtubeId = extrairYoutubeId(form.youtubeId);
  if (youtubeId && !REGEX_YOUTUBE.test(youtubeId)) erros.youtubeId = "ID do YouTube inválido (11 caracteres).";
  const duracao = parseDuracao(form.duracaoSegundos);
  if (duracao !== null && (Number.isNaN(duracao) || duracao <= 0)) erros.duracaoSegundos = "Use segundos ou mm:ss.";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(str(form.dataPublicacao))) erros.dataPublicacao = "Informe a data de publicação.";
  if (!/^-?\d+$/.test(str(form.ordem).trim())) erros.ordem = "Inteiro.";

  (form.capitulos || []).forEach((c, i) => {
    const s = parseDuracao(c.s);
    if (s === null || Number.isNaN(s) || !str(c.titulo).trim()) erros[`capitulos.${i}`] = "Capítulo precisa de tempo (segundos ou mm:ss) e título.";
  });
  (form.telas || []).forEach((t, i) => {
    const rota = str(t.rota).trim();
    const s = parseDuracao(t.s);
    if (!rota || rota.charAt(0) !== "/") erros[`telas.${i}`] = "Rota precisa começar com /.";
    else if (s !== null && (Number.isNaN(s) || s < 0)) erros[`telas.${i}`] = "Tempo inválido.";
  });
  (form.passos || []).forEach((p, i) => {
    if (!str(p).trim()) erros[`passos.${i}`] = "Passo vazio.";
  });
  return erros;
}

export function payloadDoForm(form) {
  const duracao = parseDuracao(form.duracaoSegundos);
  const permissao = str(form.permissao)
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  return {
    codigo: str(form.codigo).trim(),
    titulo: str(form.titulo).trim(),
    resumo: str(form.resumo).trim() || null,
    produtos: (form.produtos || []).slice(),
    permissao: permissao.length ? permissao.join(",") : null,
    youtubeId: extrairYoutubeId(form.youtubeId) || null,
    duracaoSegundos: duracao === null || Number.isNaN(duracao) ? null : duracao,
    dataPublicacao: str(form.dataPublicacao),
    ordem: Number(str(form.ordem).trim() || 0),
    status: form.status !== "inactive",
    capitulos: (form.capitulos || []).map((c) => ({ s: parseDuracao(c.s) || 0, titulo: str(c.titulo).trim() })),
    telas: (form.telas || []).map((t) => {
      const tela = { rota: str(t.rota).trim(), s: parseDuracao(t.s) || 0 };
      if (str(t.aba).trim()) tela.aba = str(t.aba).trim().toLowerCase();
      return tela;
    }),
    passos: (form.passos || []).map((p) => str(p).trim()),
    conteudoTexto: str(form.conteudoTexto).trim() || null,
  };
}

export function ativo(t) {
  return !(t && (t.status === false || t.status === 0 || t.status === "0"));
}
